import { createFileRoute } from "@tanstack/react-router";
import { PlannerPage } from "@/features/planner/planner-page";

/** Pro: every active wedding on one screen. Below Pro the API answers PLAN_REQUIRED and the page shows the offer. */
export const Route = createFileRoute("/app/planner")({ component: PlannerPage });
